export default "__VITE_ASSET__6bb5e0a1__"